import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#fff";
function WAN({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  fillRule="evenodd" d="M5.25 8.318l2 .847v4.765L12 11.09l4.796 2.84V9.165l1.954-.847v8.98L12 13.312l-6.75 3.986zm.227-.367L12 4.125l6.569 3.826-1.773.733L12 5.912 7.25 8.684zm1.41 8.866l1.477-.848 3.659 2.119 3.613-2.119 1.523.848-5.136 3.058z" clipRule="evenodd" /><path  fillRule="evenodd" d="M5.25 8.318l2 .847v4.765L12 11.09l4.796 2.84V9.165l1.954-.847v8.98L12 13.312l-6.75 3.986zm.227-.367L12 4.125l6.569 3.826-1.773.733L12 5.912 7.25 8.684zm1.41 8.866l1.477-.848 3.659 2.119 3.613-2.119 1.523.848-5.136 3.058z" clipRule="evenodd" /></Svg>;
}
WAN.DefaultColor = DefaultColor;
export default WAN;